import { useCallback, useState } from "react";
import { getAvaliblePlatforms, setAvaliblePlatforms, getClientDomain, getToken } from "../utils/Common";
import { PROVIDERS_STORAGE_KEY } from "../config/providers";

export const usePlatforms = () => {
    const [platforms, setPlatforms] = useState(getAvaliblePlatforms() ? getAvaliblePlatforms() : null);

    // const getPlatforms = useCallback(async (idCliente, signal) => {
    //     const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/client`, {
    //         method: 'GET',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'authorization': `Bearer ${getToken()}`
    //         },
    //         signal: signal
    //     });
        
    //     const result = await response.json();
    //     if (result?.payload?.length > 0) {
    //         setAvaliblePlatforms(result.payload);
    //         setPlatforms(result.payload);
    //         return (result.payload);
    //     }
    //     else {
    //         setAvaliblePlatforms([])
    //         setPlatforms([]);
    //         return ([])
    //     }
    // }, [])

    const getPlatforms = useCallback(async (idCliente, signal) => {
        try {
            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/client`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
    
            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }
    
            const result = await response.json();
    
            if (result?.payload?.length > 0) {
                setAvaliblePlatforms(result.payload);
                setPlatforms(result.payload);
                return result.payload;
            } else {
                setAvaliblePlatforms([]);
                setPlatforms([]);
                return [];
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                // Maneja otros errores según sea necesario (por ejemplo, puedes agregar lógica para mostrar un mensaje en la UI).
            }
            return []; // Retorna un array vacío en caso de error o aborto.
        }
    }, []);
    

    const getAllPlatforms = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/platforms/s/all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        
        const result = await response.json();
        if (result?.payload?.length > 0) {
            setAvaliblePlatforms(result.payload);
            setPlatforms(result.payload);
            return (result.payload);
        }
        else {
            setAvaliblePlatforms([])
            setPlatforms([]);
            return ([])
        }
    }, [])

    const getAllPlatformsClient = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/client`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        
        const result = await response.json();
        if (result?.payload?.length > 0) {
            setAvaliblePlatforms(result.payload);
            setPlatforms(result.payload);
            return (result.payload);
        }
        else {
            setAvaliblePlatforms([])
            setPlatforms([]);
            return ([])
        }
    }, []);

    const getAllPlatformsArching = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/arching`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        
        const result = await response.json();
        if (result?.payload?.length > 0) {
            setAvaliblePlatforms(result.payload);
            setPlatforms(result.payload);
            return (result.payload);
        }
        else {
            setAvaliblePlatforms([])
            setPlatforms([]);
            return ([])
        }
    }, [])

    const updateDetails = useCallback(async (dataToSend) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/details` , {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(dataToSend)
        });
        const result = await response.json();
        
        return result.payload;
    }, [])

    const getPlatformDetails = useCallback(async (idPlataforma, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/platformDetails/${idPlataforma}` , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        
        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload[0]);
        else return ({ Result: 0});
    }, [])

    const openLocker = useCallback(async (dataToSend) => {
        const response = await fetch(`${getClientDomain()}/platforms/doors/openLocker` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(dataToSend)
        });
        
        const result = await response.json();
        if (result) return (result);
        else return ([]);
    }, [])

    const createPlatform = useCallback(async (data, signal) => {
        const response = await fetch(`${localStorage.getItem("country")==='us' ? getClientDomain() + '/platforms/golocker/create' : getClientDomain(2) + '/dashboard/platforms/create'}` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
           body: JSON.stringify(data),
           signal: signal
        });
        
        const result = await response.json();

        if (result) return (result);
        else return ([]);
    }, [])

    const getDoors = useCallback(async (idPlataforma, signal) => {
        const response = await fetch(`${getClientDomain()}/platforms/doors/available` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({ plataforma: idPlataforma }),
            signal: signal
        });

        // The endpoint 404s on some environments, and a 404 body is HTML, so
        // parsing it blindly threw `Unexpected token '<'` — an uncaught error
        // every time a locker was picked. No doors is a legitimate answer here.
        if (!response.ok) return ([]);

        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload);
        else return ([]);
    }, []);


    const getDoorsByPlatform = useCallback(async (idPlataforma, signal) => {
        const response = await fetch(`${getClientDomain(2)}/doors/location/${idPlataforma}` , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        
        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload);
        else return ([]);
    }, []);

    const getModulesByPlatform = useCallback(async (idPlataforma, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/modules/${idPlataforma}` , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload);
        else return ([]);
    }, []);

    const openDoor = useCallback(async (dataToSend) => {
        const response = await fetch(`${getClientDomain(2)}/doors/open` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(dataToSend)
        });
        
        const result = await response.json();
        if (result) return (result);
        else return ([]);
    }, []);

    const actionInPlatform = useCallback(async (dataToSend) => {
        const response = await fetch(`${getClientDomain(2)}/doors/actions/${dataToSend.actionId}` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(dataToSend)
        });
        
        const result = await response.json();
        if (result) return (result);
        else return ([]);
    }, []);

    const rebootLocation = useCallback(async (dataToSend) => {
        const response = await fetch(`${getClientDomain(2)}/settings/reboot` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(dataToSend)
        });
        
        const result = await response.json();
        if (result) return (result);
        else return ([]);
    }, []);

    const archingPlatformById = useCallback(async (signal, data) => {
        
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/arching` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });
        
        const result = await response.json();
        if (result) return (result);
        else return ([]);
    }, []);

    const getQrCodeAccess = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/access/qrCode` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });
        
        const result = await response.json();
        if (result) return (result);
        else return ([]);
    }, []);

    const getPlatformDetailsByExternalId = useCallback(async (externalId, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/details/${externalId}` , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();        
                
        if (result?.payload?.length > 0) return (result.payload[0]);
        else return (null);
    }
    , []);

    const getSettingByPlatform = useCallback(async (locationId, signal) => {
        const response = await fetch(`${getClientDomain()}/settings/${locationId}` , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        const result = await response.json();
        if (result?.payload) return result.payload;
        return null;
    }, []);

    const createSettingsPlatform = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain()}/settings/create` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
           body: JSON.stringify(data),
           signal: signal
        });
        
        const result = await response.json();

        if (result) return (result);
        else return ([]);
    }, [])

    const getProviderPlatforms = useCallback(async (signal) => {
        // Verificar si ya existen datos en sessionStorage
        const storedData = sessionStorage.getItem(PROVIDERS_STORAGE_KEY);
        if (storedData) {
            // Si hay datos en sessionStorage, devolverlos parseados
            return JSON.parse(storedData);
        }
    
        try {
            // Realizar la solicitud solo si no hay datos almacenados
            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/providers`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal: signal
            });
    
            const result = await response.json();
    
            if (result?.payload?.length > 0) {
                // Almacenar los datos en sessionStorage
                sessionStorage.setItem(PROVIDERS_STORAGE_KEY, JSON.stringify(result.payload));
                return result.payload;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching provider platforms:', error);
            return [];
        }
    }, []);
    

    const createModulesPlatform = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain()}/modules/create` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
                },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result) return (result);
        else return ([]);
        }, []);

        const createDoorsPlatforms = useCallback(async (data, signal) => {
            const response = await fetch(`${localStorage.getItem("country")==='us' ? getClientDomain() + '/doors/golocker/create' : getClientDomain(2) + '/doors/create'}` , {

                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                    },
                    body: JSON.stringify(data),
                    signal: signal
                    });

            const result = await response.json();
            if (result) return (result);
            else return ([]);
            }, []);

        const updateGeneralDataPlatform = useCallback(async (data, signal) => {
            const response = await fetch(`${localStorage.getItem("country")==='us' ? getClientDomain() + '/platforms/golocker/update/'+ data.locationId : getClientDomain(2) + '/dashboard/platforms/update/'+ data.locationId }` , {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                    },
                body: JSON.stringify(data),
                signal: signal
                });

            const result = await response.json();
            if (result) return (result);
            else return ([]);
            }
            , []);

            const updateSettingsPlatform = useCallback(async (data, signal) => {
                
                const response = await fetch(`${getClientDomain()}/settings/${data?.locationId}` , {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    },
                   body: JSON.stringify(data),
                   signal: signal
                });
                
                const result = await response.json();
        
                if (result) return (result);
                else return ([]);
            }, []);

            const updateModulesPlatform = useCallback(async (data, signal) => {
                
                const response = await fetch(`${getClientDomain()}/modules/${data?.moduleId}` , {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    },
                   body: JSON.stringify(data),
                   signal: signal
                });
                
                const result = await response.json();
        
                if (result) return (result);
                else return ([]);
            }, []);

            const updateDoorPlatform = useCallback(async (data, signal) => {

                const response = await fetch(`${localStorage.getItem("country")==='us' ? getClientDomain() + '/doors/golocker/'+ data?.doorId : getClientDomain(2) + '/doors/'+ data?.doorId }` , {

                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    },
                    body: JSON.stringify(data),
                    signal: signal
                });

                const result = await response.json();
                if (result) return (result);
                else return ([]);
                }, []);

            // valida que no tenga paquetes, borra sus asignaciones de empresa y avisa al locker
            const deleteDoorPlatform = useCallback(async (doorId, signal) => {
                const response = await fetch(`${getClientDomain(2)}/doors/${doorId}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    },
                    signal: signal
                });

                const result = await response.json();
                return result || {};
            }, []);

                const syncLocationToLocker = useCallback(async (data, signal) => {
                    const response = await fetch(`${localStorage.getItem("country")==='us' ? getClientDomain() + '/platforms/golocker/jwt/sync' : getClientDomain(2) + '/platforms/jwt/sync'}` , {

                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': `Bearer ${getToken()}`
                        },
                        body: JSON.stringify(data),
                        signal: signal
                        });

                    const result = await response.json();
                    if (result) return (result);
                    else return ([]);
                    }, []);

                    const syncSettingsToLocker = useCallback(async (data, signal) => {
                        
                        const response = await fetch(`${getClientDomain()}/settings/jwt/sync` , {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': `Bearer ${getToken()}`
                            },
                            body: JSON.stringify(data),
                            signal: signal
                        });

                        const result = await response.json();
                        if (result) return (result);
                        else return ([]);
                        }
                        , []);

                        const syncModuleToLocker = useCallback(async (data, signal) => {
                            
                            const response = await fetch(`${getClientDomain()}/modules/jwt/sync` , {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'authorization': `Bearer ${getToken()}`
                                },
                                body: JSON.stringify(data),
                                signal: signal
                            });

                            const result = await response.json();
                            if (result) return (result);
                            else return ([]);
                            }, []);

                            const syncDoorToLocker = useCallback(async (data, signal) => {
                            
                                const response = await fetch(`${getClientDomain(2)}/doors/jwt/sync` , {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'authorization': `Bearer ${getToken()}`
                                    },
                                    body: JSON.stringify(data),
                                    signal: signal
                                });
    
                                const result = await response.json();
                                if (result) return (result);
                                else return ([]);
                                }, []);

                            
                                const forceSynchronization = useCallback(async (data, signal) => {
                            
                                    const response = await fetch(`${getClientDomain()}/platforms/sync/ext/${data?.locationId}` , {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'authorization': `Bearer ${getToken()}`
                                        },
                                        body: JSON.stringify(data),
                                        signal: signal
                                    });
        
                                    const result = await response.json();
                                    if (result) return (result);
                                    else return ([]);
                                    }, []);

    const duplicatePlatform = useCallback(async (jobId, data, signal) => {
        try {
            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/duplicate/${jobId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(data),
                signal: signal
            });
            
            const result = await response.json();
            
            if (!response.ok) {
                throw new Error(JSON.stringify({
                    status: response.status,
                    statusText: response.statusText,
                    code: result?.code || 'UNKNOWN_ERROR',
                    message: result?.message || result?.error || 'Error desconocido'
                }));
            }
            
            return result;
        } catch (error) {
            if (error.name === 'AbortError') {
                throw error;
            }
            
            // If it's already a stringified error object, parse it
            if (typeof error.message === 'string' && error.message.startsWith('{')) {
                throw new Error(error.message);
            }
            
            // If it's a network error or other type, create a generic error
            throw new Error(JSON.stringify({
                status: 'NETWORK_ERROR',
                statusText: 'Network Error',
                code: 'NETWORK_ERROR',
                message: error.message || 'Error de conexión'
            }));
        }
    }, []);


    // Door-company assignment
    const assignCompanyToDoor = useCallback(async (idPlataformaDet, companyCode, signal) => {
        const response = await fetch(`${getClientDomain()}/doors/company/${idPlataformaDet}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({ companyCode }),
            signal
        });
        const result = await response.json();
        return result;
    }, []);

    const removeCompanyFromDoor = useCallback(async (idPlataformaDet, companyCode, signal) => {
        const response = await fetch(`${getClientDomain()}/doors/company/${idPlataformaDet}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({ companyCode }),
            signal
        });
        const result = await response.json();
        return result;
    }, []);

    const getCompaniesByDoor = useCallback(async (idPlataformaDet, signal) => {
        try {
            const response = await fetch(`${getClientDomain()}/doors/company/${idPlataformaDet}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
            
            if (!response.ok) {
                // If 404, check if it's just "no data"
                if (response.status === 404) {
                    const errorResult = await response.json().catch(() => ({}));
                    if (errorResult?.message?.includes('NO_ASSIGNMENTS') || errorResult?.message?.includes('NOT_FOUND')) {
                        // No assignments found is not an error, return empty array
                        return [];
                    }
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result?.assignments ?? result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                // If error indicates "no data", return empty array instead of throwing
                if (error.message?.includes('404') || error.message?.includes('NOT_FOUND') || error.message?.includes('NO_ASSIGNMENTS')) {
                    return [];
                }
                console.error('Error getting companies by door:', error);
                throw error;
            }
            return [];
        }
    }, []);

    const getCompanies = useCallback(async (signal, page, pageSize, filters = {}) => {
        try {
            let url = `${getClientDomain(2)}/companies`;
            const params = new URLSearchParams();
            
            if (page && pageSize) {
                params.append('page', page);
                params.append('pageSize', pageSize);
            }
            
            // Agregar filtros específicos por campo
            if (filters.name && filters.name.trim()) {
                params.append('name', filters.name.trim());
            } else if (filters.companyCode && filters.companyCode.trim()) {
                params.append('companyCode', filters.companyCode.trim());
            } else if (filters.email && filters.email.trim()) {
                params.append('email', filters.email.trim());
            } else if (filters.contactName && filters.contactName.trim()) {
                params.append('contactName', filters.contactName.trim());
            }
            
            if (filters.status) {
                params.append('status', filters.status);
            }
            
            if (params.toString()) {
                url += `?${params.toString()}`;
            }
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
            
            if (!response.ok) {
                if (response.status === 404) {
                    const errorResult = await response.json().catch(() => ({}));
                    if (errorResult?.message?.includes('NO_COMPANIES') || errorResult?.message?.includes('NOT_FOUND')) {
                        return { code: 200, payload: [], companiesQty: 0, total: 0 };
                    }
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                if (error.message?.includes('404') || error.message?.includes('NOT_FOUND') || error.message?.includes('NO_COMPANIES')) {
                    return { code: 200, payload: [], companiesQty: 0, total: 0 };
                }
                console.error('Error getting companies:', error);
                throw error;
            }
            return { code: 200, payload: [], companiesQty: 0, total: 0 };
        }
    }, []);

    const getDoorCompanyAssignments = useCallback(async (idPlataforma, signal) => {
        try {
            const response = await fetch(`${getClientDomain()}/doors/company/platform/${idPlataforma}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
            
            if (!response.ok) {
                // If 404, check if it's just "no data"
                if (response.status === 404) {
                    const errorResult = await response.json().catch(() => ({}));
                    if (errorResult?.message?.includes('NO_ASSIGNMENTS') || errorResult?.message?.includes('NOT_FOUND')) {
                        // No assignments found is not an error, return empty array
                        return [];
                    }
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result?.assignments || [];
        } catch (error) {
            if (error.name !== 'AbortError') {
                // If error indicates "no data", return empty array instead of throwing
                if (error.message?.includes('404') || error.message?.includes('NOT_FOUND') || error.message?.includes('NO_ASSIGNMENTS')) {
                    return [];
                }
                console.error('Error getting door company assignments:', error);
                throw error;
            }
            return [];
        }
    }, []);

    const getDoorsByCompanyCode = useCallback(async (companyCode, signal) => {
        try {
            const response = await fetch(`${getClientDomain(2)}/companies/${companyCode}/doors`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
            
            if (!response.ok) {
                // If endpoint doesn't exist (404), try alternative endpoint
                if (response.status === 404) {
                    try {
                        const altResponse = await fetch(`${getClientDomain()}/companies/doors/${companyCode}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': `Bearer ${getToken()}`
                            },
                            signal
                        });
                        if (altResponse.ok) {
                            const altResult = await altResponse.json();
                            if (altResult?.payload) {
                                return Array.isArray(altResult.payload) ? altResult.payload : [];
                            } else if (Array.isArray(altResult)) {
                                return altResult;
                            } else if (altResult?.doors) {
                                return Array.isArray(altResult.doors) ? altResult.doors : [];
                            }
                        }
                    } catch (altError) {
                        // If alternative endpoint also fails, return empty array instead of throwing
                        return [];
                    }
                }
                // For other errors, check if it's a "no data" scenario
                const errorResult = await response.json().catch(() => ({}));
                if (response.status === 404 && (errorResult?.message?.includes('NOT_FOUND') || errorResult?.message?.includes('NO_DOORS'))) {
                    // No doors found is not an error, just return empty array
                    return [];
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            // Handle different response formats
            if (result?.payload) {
                return Array.isArray(result.payload) ? result.payload : [];
            } else if (Array.isArray(result)) {
                return result;
            } else if (result?.doors) {
                return Array.isArray(result.doors) ? result.doors : [];
            } else if (result?.assignments) {
                return Array.isArray(result.assignments) ? result.assignments : [];
            }
            return [];
        } catch (error) {
            if (error.name !== 'AbortError') {
                // If error message indicates "not found" or "no data", return empty array
                if (error.message?.includes('404') || error.message?.includes('NOT_FOUND') || error.message?.includes('NO_DOORS')) {
                    return [];
                }
                console.error('Error getting doors by company code:', error);
                throw error;
            }
            return [];
        }
    }, []);

    const getCompanyById = useCallback(async (companyCode, signal) => {
        try {
            const response = await fetch(`${getClientDomain(2)}/companies/${companyCode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
            const result = await response.json();
            // Si no hay endpoint específico, buscar en la lista
            if (response.status === 404 || !result) {
                const allCompanies = await getCompanies(signal);
                const list = Array.isArray(allCompanies) ? allCompanies : (allCompanies?.payload || []);
                return list.find(c => c.companyCode === companyCode || c.boxitCompanyCode === companyCode) || null;
            }
            return result?.payload || result?.data || result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error getting company by id:', error);
                // Si falla, intentar buscar en la lista
                try {
                    const allCompanies = await getCompanies(signal);
                    const list = Array.isArray(allCompanies) ? allCompanies : (allCompanies?.payload || []);
                    return list.find(c => c.companyCode === companyCode || c.boxitCompanyCode === companyCode) || null;
                } catch (e) {
                    throw error;
                }
            }
        }
    }, [getCompanies]);

    const getAssignedMembersById = useCallback(async (companyId, page = 1, pageSize = 10, signal) => {
        try {
            const response = await fetch(`${getClientDomain(2)}/companies/members/${companyId}?page=${page}&pageSize=${pageSize}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });
            
            if (!response.ok) {
                // If 404 or other error, check if it's just "no data"
                if (response.status === 404) {
                    const errorResult = await response.json().catch(() => ({}));
                    if (errorResult?.message?.includes('NO_ASSIGNED_MEMBERS') || errorResult?.message?.includes('NOT_FOUND')) {
                        // No members found is not an error, return empty structure
                        return { code: 200, message: "NO_ASSIGNED_MEMBERS_FOUND", total: 0, members: [] };
                    }
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            // Retornar el resultado completo para manejar { code, message, total, members }
            return result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                // If error indicates "no data", return empty structure instead of throwing
                if (error.message?.includes('404') || error.message?.includes('NOT_FOUND') || error.message?.includes('NO_ASSIGNED_MEMBERS')) {
                    return { code: 200, message: "NO_ASSIGNED_MEMBERS_FOUND", total: 0, members: [] };
                }
                console.error('Error getting assigned members:', error);
                throw error;
            }
            return { code: 200, message: "NO_ASSIGNED_MEMBERS_FOUND", total: 0, members: [] };
        }
    }, []);

    const updateCompany = useCallback(async (companyCode, data, signal) => {
        try {
            // Only allow specific fields that the endpoint accepts
            const allowedFields = [
                'companyName',
                'contactPrimaryEmail',
                'contactPrimaryFirstName',
                'contactPrimaryLastName',
                'logoBase64',
                'isActive',
                'lockerConsolidation'
            ];
            
            // Filter data to only include allowed fields
            const filteredData = {};
            allowedFields.forEach(field => {
                if (data[field] !== undefined && data[field] !== null) {
                    filteredData[field] = data[field];
                }
            });
            
            const response = await fetch(`${getClientDomain(2)}/companies/${companyCode}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(filteredData),
                signal
            });
            const result = await response.json();
            if (result) return result;
            else return [];
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error updating company:', error);
                throw error;
            }
        }
    }, []);

    const updateCompanyLogo = useCallback(async (companyCode, logoFile, signal) => {
        try {
            // Convert File to base64
            const base64Logo = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Remove data:image/...;base64, prefix
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };
                reader.onerror = reject;
                reader.readAsDataURL(logoFile);
            });
            
            // Create JSON payload with base64 logo
            const jsonData = {
                logoBase64: base64Logo
            };
            
            const response = await fetch(`${getClientDomain(2)}/companies/${companyCode}/logo`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(jsonData),
                signal
            });
            const result = await response.json();
            if (result) return result;
            else return [];
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error updating company logo:', error);
                throw error;
            }
        }
    }, []);

    const createCompany = useCallback(async (companyData, signal) => {
        try {
            const response = await fetch(`${getClientDomain(2)}/companies`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(companyData),
                signal
            });
            
            if (!response.ok) {
                const errorResult = await response.json().catch(() => ({}));
                throw new Error(errorResult.message || `HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error creating company:', error);
                throw error;
            }
        }
    }, []);

    // Sync manual de una compañía y de una asignación cliente-compañía (solo api de USA).
    // Firma sin `signal` para poder usarse desde BtnSync, igual que el resto de los sync.
    const syncCompanyToLocker = useCallback(async (data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/companies/sync`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();
        return result;
    }, []);

    const syncAssignmentToLocker = useCallback(async (data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/companies/assignments/sync`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();
        return result;
    }, []);

    const removeClientFromCompany = useCallback(async (clientId, companyCode, signal) => {
        try {
            const response = await fetch(`${getClientDomain()}/clients/company/${clientId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify({ companyCode }),
                signal
            });
            
            if (!response.ok) {
                const errorResult = await response.json().catch(() => ({}));
                throw new Error(errorResult.message || `HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error removing client from company:', error);
                throw error;
            }
        }
    }, []);

    const assignClientToCompany = useCallback(async (clientId, companyCode, additionalFields = {}, signal) => {
        try {
            const response = await fetch(`${getClientDomain()}/clients/company/${clientId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify({ 
                    companyCode,
                    ...additionalFields
                }),
                signal
            });
            
            if (!response.ok) {
                const errorResult = await response.json().catch(() => ({}));
                throw new Error(errorResult.message || `HTTP ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result;
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error assigning client to company:', error);
                throw error;
            }
        }
    }, []);

    const getAllAssignments = useCallback(async (userIdGL, signal) => {
        try {
            const response = await fetch(`${getClientDomain()}/clients/company/${userIdGL}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal
            });

            if (!response.ok) {
                const errorResult = await response.json().catch(() => ({}));
                // NO_ASSIGNMENTS_FOUND no es un error crítico, retornamos array vacío
                if (errorResult?.message === 'NO_ASSIGNMENTS_FOUND' || response.status === 404) {
                    return [];
                }
                throw new Error(errorResult?.message || `HTTP ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();
            // Backend retorna: { code, message, quantity, payload: assignments[] }
            return Array.isArray(result?.payload) ? result.payload : [];
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error getting assignments by client:', error);
                // Si el error es NO_ASSIGNMENTS_FOUND, retornar array vacío
                if (error.message?.includes('NO_ASSIGNMENTS_FOUND')) {
                    return [];
                }
                throw error;
            }
            return [];
        }
    }, []);

    return { platforms, getQrCodeAccess, getPlatforms, getAllPlatforms, getDoors, getPlatformDetails, updateDetails, openLocker, createPlatform, getAllPlatformsClient, getDoorsByPlatform, openDoor, actionInPlatform, rebootLocation, getAllPlatformsArching, archingPlatformById, getPlatformDetailsByExternalId, getSettingByPlatform, createSettingsPlatform, getProviderPlatforms, createModulesPlatform, getModulesByPlatform, createDoorsPlatforms, updateGeneralDataPlatform, updateSettingsPlatform, updateModulesPlatform, updateDoorPlatform, deleteDoorPlatform, syncLocationToLocker, syncSettingsToLocker, syncModuleToLocker, syncDoorToLocker, forceSynchronization, duplicatePlatform, assignCompanyToDoor, removeCompanyFromDoor, getCompaniesByDoor, getCompanies, getCompanyById, getDoorCompanyAssignments, getDoorsByCompanyCode, getAssignedMembersById, updateCompany, updateCompanyLogo, createCompany, removeClientFromCompany, assignClientToCompany, getAllAssignments, syncCompanyToLocker, syncAssignmentToLocker }
}